// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as VolunteerRouteImport } from './routes/volunteer'
import { Route as TicketsRouteImport } from './routes/tickets'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as PressRouteImport } from './routes/press'
import { Route as PartnersRouteImport } from './routes/partners'
import { Route as MapRouteImport } from './routes/map'
import { Route as GalleryRouteImport } from './routes/gallery'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as CampsRouteImport } from './routes/camps'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProgramIndexRouteImport } from './routes/program/index'
import { Route as ArtistsIndexRouteImport } from './routes/artists/index'
import { Route as AboutIndexRouteImport } from './routes/about/index'
import { Route as ProgramKidsRouteImport } from './routes/program/kids'
import { Route as ProgramDaytimeRouteImport } from './routes/program/daytime'
import { Route as ArtistsSlugRouteImport } from './routes/artists/$slug'
import { Route as AboutRulesRouteImport } from './routes/about/rules'
import { Route as AboutFaqRouteImport } from './routes/about/faq'
import { Route as CampsIndexRouteImport } from './routes/camps/index'
import { Route as CampsCampSlugRouteImport } from './routes/camps/$campSlug'

const VolunteerRoute = VolunteerRouteImport.update({
            id: '/volunteer',path: '/volunteer',getParentRoute: () => rootRouteImport
          })
const TicketsRoute = TicketsRouteImport.update({
            id: '/tickets',path: '/tickets',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const PressRoute = PressRouteImport.update({
            id: '/press',path: '/press',getParentRoute: () => rootRouteImport
          })
const PartnersRoute = PartnersRouteImport.update({
            id: '/partners',path: '/partners',getParentRoute: () => rootRouteImport
          })
const MapRoute = MapRouteImport.update({
            id: '/map',path: '/map',getParentRoute: () => rootRouteImport
          })
const GalleryRoute = GalleryRouteImport.update({
            id: '/gallery',path: '/gallery',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const CampsRoute = CampsRouteImport.update({
            id: '/camps',path: '/camps',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ProgramIndexRoute = ProgramIndexRouteImport.update({
            id: '/program/',path: '/program/',getParentRoute: () => rootRouteImport
          })
const ArtistsIndexRoute = ArtistsIndexRouteImport.update({
            id: '/artists/',path: '/artists/',getParentRoute: () => rootRouteImport
          })
const AboutIndexRoute = AboutIndexRouteImport.update({
            id: '/about/',path: '/about/',getParentRoute: () => rootRouteImport
          })
const ProgramKidsRoute = ProgramKidsRouteImport.update({
            id: '/program/kids',path: '/program/kids',getParentRoute: () => rootRouteImport
          })
const ProgramDaytimeRoute = ProgramDaytimeRouteImport.update({
            id: '/program/daytime',path: '/program/daytime',getParentRoute: () => rootRouteImport
          })
const ArtistsSlugRoute = ArtistsSlugRouteImport.update({
            id: '/artists/$slug',path: '/artists/$slug',getParentRoute: () => rootRouteImport
          })
const AboutRulesRoute = AboutRulesRouteImport.update({
            id: '/about/rules',path: '/about/rules',getParentRoute: () => rootRouteImport
          })
const AboutFaqRoute = AboutFaqRouteImport.update({
            id: '/about/faq',path: '/about/faq',getParentRoute: () => rootRouteImport
          })
const CampsIndexRoute = CampsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => CampsRoute
          })
const CampsCampSlugRoute = CampsCampSlugRouteImport.update({
            id: '/$campSlug',path: '/$campSlug',getParentRoute: () => CampsRoute
          })





const CampsRouteChildren = {
  CampsCampSlugRoute: CampsCampSlugRoute,CampsIndexRoute: CampsIndexRoute
}

const CampsRouteWithChildren = CampsRoute._addFileChildren(CampsRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,CampsRoute: CampsRouteWithChildren,ContactRoute: ContactRoute,GalleryRoute: GalleryRoute,MapRoute: MapRoute,PartnersRoute: PartnersRoute,PressRoute: PressRoute,PrivacyRoute: PrivacyRoute,TicketsRoute: TicketsRoute,VolunteerRoute: VolunteerRoute,AboutFaqRoute: AboutFaqRoute,AboutRulesRoute: AboutRulesRoute,ArtistsSlugRoute: ArtistsSlugRoute,ProgramDaytimeRoute: ProgramDaytimeRoute,ProgramKidsRoute: ProgramKidsRoute,AboutIndexRoute: AboutIndexRoute,ArtistsIndexRoute: ArtistsIndexRoute,ProgramIndexRoute: ProgramIndexRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)